import { render, staticRenderFns } from "./comHide.vue?vue&type=template&id=2b671ec6&"
import script from "./comHide.vue?vue&type=script&lang=js&"
export * from "./comHide.vue?vue&type=script&lang=js&"
import style0 from "./comHide.vue?vue&type=style&index=0&id=2b671ec6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports